import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';

export function buildStage7(_tl: GSAPTimeline, _refs: AnimationRefs, _viewport: Viewport) {}
